
import '../styles/main.scss'
import '../images/icons/config.font.json'

// https://github.com/VodkaBears/Remodal
import 'remodal'

// Libs
import slider from './lib/slider'
import familyAnswer from './lib/family-answer'
import mobileNav from './lib/mobile-nav'
import floatedLabel from './lib/floated-label'

// Launch scripts
slider()
familyAnswer()
mobileNav()
floatedLabel()



// WEBPACK FOOTER //
// ./scripts/main.js